import { Component } from "@angular/core";
import { RazorpayCallback } from "../../re-payment.interface";
import { LoanDashboardService } from "../../../../loan-dashboard.service";
import { UntilDestroy } from "@ngneat/until-destroy";
import { Subscription, take } from "rxjs";
import { DocumentTypeOfSummary } from "src/app/shared/common.interface";
import { GlobalService } from "src/app/shared/services/global.service";
import { RePaymentService } from "../../re-payment.service";
import { Lottie } from "src/app/shared/constant/lottie";
@UntilDestroy({ arrayName: "subscriptions" })
@Component({
    selector: "web-repay-successful",
    templateUrl: "./repay-successful.component.html",
    styleUrls: ["./repay-successful.component.scss"],
})
export class RepaySuccessfulComponent {
    subscriptions: Subscription[] = [];
    txnDetails: any;
    applicationId: any;
    isDownloadSummary = false;
    isDownloadNoc = false;
    showSimmer = false;
    nocPdf = "";
    rewardPointMsg: any;

    constructor(
        private loanDashboardService: LoanDashboardService,
        private rePaymentService: RePaymentService,
        private globalService: GlobalService,
        public lottie: Lottie
    ) {}

    ngOnInit() {
        const navState = history?.state;

        if (navState && Object.keys(navState).length) {
            this.razorpayCallback(navState);
        }
    }

    razorpayCallback(details: RazorpayCallback) {
        if (!details) {
            return;
        }

        this.showSimmer = true;

        this.subscriptions.push(
            this.rePaymentService
                .paymentCallback({ ...details })
                .pipe(take(1))
                .subscribe({
                    next: (res: any) => {
                        if (res?.success && Object.keys(res?.data || {}).length > 0) {
                            this.txnDetails = res.data?.payment;
                            this.nocPdf = res.data?.nocPdf;
                            this.applicationId = this.txnDetails?.applicationId ?? 0;
                            this.rewardPointMsg = res.data?.rewardPoint;
                            this.showSimmer = false;
                        } else {
                            this.showSimmer = false;
                        }
                    },
                    error: () => {
                        this.showSimmer = false;
                    },
                })
        );
    }

    submit() {
        this.loanDashboardService.getDashboardDetails();
    }

    downloadSummary() {
        this.isDownloadSummary = true;

        this.globalService
            .downloadSummary(
                DocumentTypeOfSummary.PAYMENT_RECEIPT,
                "PAYMENT_RECEIPT",
                this.txnDetails?.paymentResponseId?.toString(),
                this.applicationId?.toString()
            )
            .then(() => {
                this.isDownloadSummary = false;
            })
            .finally(() => {
                this.isDownloadSummary = false;
            });
    }

    async downloadPdf(url?: string, fileName: string = "file", type: string = "pdf") {
        this.isDownloadNoc = true;
        await this.globalService
            .downloadPdf(url, fileName, type, this.txnDetails?.applicationId ?? "")
            .then(() => {
                this.isDownloadNoc = false;
            })
            .finally(() => {
                this.isDownloadNoc = false;
            });
    }
}
